import React, { ComponentProps } from 'react'

import { faClose } from '@fortawesome/pro-regular-svg-icons'
import { Alert, AlertTitle, Slide, SlideProps, Snackbar as MuiSnackBar, styled, Typography } from '@mui/material'

import { Icon } from '../Icon/Icon'
import { IconButton } from '../IconButton/IconButton'

export type ToastContent = {
  open: boolean
  title: string
  content: string
  severity: 'success' | 'error' | 'warning' | 'info'
}

export type ToastProps = Omit<ComponentProps<typeof MuiSnackBar>, 'anchorOrigin' | 'message' | 'open'> & ToastContent

const SlideTransition: React.FC<SlideProps> = (props) => {
  return <Slide {...props} direction={props.in ? 'up' : 'left'} />
}


export const Toast: React.FC<ToastProps> = ({ title, content, severity, children, ...props }) => {
  return (
    <MuiSnackBar
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      autoHideDuration={6000}
      TransitionComponent={SlideTransition}
      {...props}
    >
      <StyledAlert
        severity={severity}
        action={
          <IconButton
            round
            aria-label="close"
            color="inherit"
            size="small"
            onClick={(ev) => props?.onClose && props.onClose(ev, 'clickaway')}
          >
            <Icon icon={faClose} fontSize="inherit" />
          </IconButton>
        }
      >
        <AlertTitle>{title}</AlertTitle>
        <div dangerouslySetInnerHTML={{ __html: content }}></div>
        {children}
      </StyledAlert>
    </MuiSnackBar>
  )
}

export const StyledTitle = styled(Typography)`
  font-weight: 500;
  font-size: ${({ theme }) => theme.typography.pxToRem(14)};
`

export const StyledContent = styled(Typography)`
  font-size: ${({ theme }) => theme.typography.pxToRem(12)};
`

const StyledAlert = styled(Alert)`
  max-width: ${({ theme }) => theme.typography.pxToRem(400)};
`